module.exports = __webpack_public_path__ + "img/all_jobs.1317b055.jpg";